import { Typography } from '@sunwebgroup/uds-ui/typography'
import { buildImgSrc } from '@/helpers/image-url'
import { useIntl } from '@/intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useEnv } from '@/scopes/common/infrastructure/env'
import styles from './AppPromotionSection.module.css'
import { BookingDetailsSection } from './BookingDetailsSection'

export function AppPromotionSection({ className }: { className?: string }) {
  const { formatMessage } = useIntl()
  const links = useConfiguration('links')
  const mediaServerBaseUrl = useEnv('MEDIA_SERVER_BASE_URL')

  return (
    <BookingDetailsSection isSidebar className={className} title={formatMessage({ id: 'booking_details_app_promotion_title' })}>
      <div className={styles.content}>
        <Typography as="p" variant="body-m-bold-tight">
          {formatMessage({ id: 'booking_details_app_promotion_tagline' })}
        </Typography>
        <Typography as="p" variant="body-s-regular-tight" className={styles.description}>
          {formatMessage({ id: 'booking_details_app_promotion_description' })}
        </Typography>
      </div>
      <div className={styles.appLinks}>
        <a href={links.appleStore} target="_blank" rel="noopener noreferrer">
          <img
            className={styles.downloadBadge}
            src={buildImgSrc(`${mediaServerBaseUrl}/footer/download_app_store.png`, 200)}
            alt={formatMessage({ id: 'footer_download_app_store' })}
            loading="lazy"
          />
        </a>
        <a href={links.googlePlayStore} target="_blank" rel="noopener noreferrer">
          <img
            className={styles.downloadBadge}
            src={buildImgSrc(`${mediaServerBaseUrl}/footer/download_play_store.png`, 200)}
            alt={formatMessage({ id: 'footer_download_google_play' })}
            loading="lazy"
          />
        </a>
      </div>
    </BookingDetailsSection>
  )
}
